var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6516 1.8335C4.67224 1.8335 5.49963 4.29593 5.49963 7.3335H3.6516C2.76097 7.3335 2.31566 7.3335 2.04 7.026C1.76434 6.7185 1.81233 6.31355 1.9083 5.50365C2.16167 3.36564 2.84651 1.8335 3.6516 1.8335Z",
    stroke: "#666666",
    strokeWidth: 1.375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49959 7.38323V17.0921C5.49959 18.4778 5.49959 19.1707 5.92305 19.4434C6.61506 19.8891 7.68488 18.9545 8.22289 18.6152C8.66746 18.3348 8.88974 18.1946 9.13644 18.1865C9.40301 18.1778 9.62924 18.3122 10.1096 18.6152L11.8613 19.7198C12.3338 20.0178 12.57 20.1668 12.8329 20.1668C13.0958 20.1668 13.3321 20.0178 13.8046 19.7198L15.5562 18.6152C16.0008 18.3348 16.2231 18.1946 16.4698 18.1865C16.7364 18.1778 16.9626 18.3122 17.443 18.6152C17.981 18.9545 19.0508 19.8891 19.7428 19.4434C20.1663 19.1707 20.1663 18.4778 20.1663 17.0921V7.38323C20.1663 4.76706 20.1663 3.45898 19.3608 2.64624C18.5553 1.8335 17.259 1.8335 14.6663 1.8335H3.66626",
    stroke: "#666666",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.833 7.33366C11.8204 7.33366 10.9996 7.94927 10.9996 8.70866C10.9996 9.46805 11.8204 10.0837 12.833 10.0837C13.8455 10.0837 14.6663 10.6993 14.6663 11.4587C14.6663 12.2181 13.8455 12.8337 12.833 12.8337M12.833 7.33366C13.6312 7.33366 14.3103 7.71628 14.562 8.25033M12.833 7.33366V6.41699M12.833 12.8337C12.0347 12.8337 11.3556 12.451 11.104 11.917M12.833 12.8337V13.7503",
    stroke: "#666666",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.cdddd02b3fa165a70185de8c9d98225e.svg";
export { ForwardRef as ReactComponent };